import {
    SHOP_AUDIO_PATH,
    SHOP_BEAUTY_PATH,
    SHOP_LAPTOPS_PATH,
    SHOP_HANDBAGS_PATH,
    SHOP_GAMING_PATH,
    SHOP_HOME_BASICS_PATH,
    SHOP_KIDS_PATH,
    SHOP_ELECTRONICS_PATH,
    SHOP_NEW_PRODUCTS_PATH,
    SHOP_OUTDOOR_LIVING_PATH,
    SHOP_HOME_PATH,
    SHOP_LIFESTYLE_PATH,
    SHOP_HANDBAGS_JEWELRY_PATH,
} from '@perpay-web/fintech/constants/paths';

export const AUDIO_CATEGORY = 'audio';
export const LAPTOPS_CATEGORY = 'laptops';
export const HANDBAGS_CATEGORY = 'handbags';
export const VIEDO_GAMES_CATEGORY = 'video games';
export const HOME_BASICS_CATEGORY = 'home basics';
export const KIDS_CATEGORY = 'toys';
export const ELECTRONICS_CATEGORY = 'electronics';
export const BEAUTY_CATEGORY = 'beauty';
export const NEW_PRODUCTS_CATEGORY = 'new';
export const HANDBAGS_JEWELRY_CATEGORY = 'handbags jewelry';
export const OUTDOOR_LIVING_CATEGORY = 'outdoor living';
export const HOME_CATEGORY = 'home';
export const LIFESTYLE_CATEGORY = 'lifestyle';

export const SHOP_PATHS_BY_CATEGORY = {
    [AUDIO_CATEGORY]: SHOP_AUDIO_PATH,
    [LAPTOPS_CATEGORY]: SHOP_LAPTOPS_PATH,
    [HANDBAGS_CATEGORY]: SHOP_HANDBAGS_PATH,
    [VIEDO_GAMES_CATEGORY]: SHOP_GAMING_PATH,
    [HOME_BASICS_CATEGORY]: SHOP_HOME_BASICS_PATH,
    [KIDS_CATEGORY]: SHOP_KIDS_PATH,
    [ELECTRONICS_CATEGORY]: SHOP_ELECTRONICS_PATH,
    [BEAUTY_CATEGORY]: SHOP_BEAUTY_PATH,
    [NEW_PRODUCTS_CATEGORY]: SHOP_NEW_PRODUCTS_PATH,
    [HANDBAGS_JEWELRY_CATEGORY]: SHOP_HANDBAGS_JEWELRY_PATH,
    [OUTDOOR_LIVING_CATEGORY]: SHOP_OUTDOOR_LIVING_PATH,
    [HOME_CATEGORY]: SHOP_HOME_PATH,
    [LIFESTYLE_CATEGORY]: SHOP_LIFESTYLE_PATH,
};
